import { render, staticRenderFns } from "./CardH.vue?vue&type=template&id=9b752d7c&"
import script from "./CardH.vue?vue&type=script&lang=js&"
export * from "./CardH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports